<template>
  <footer v-if="$store.state.user.check_is_wxc_domain() || $store.state.user.check_is_wxcblog_domain()" class="mt-2 main-footer d-none d-sm-block pb-2 pt-4 text-muted text-center text-small">
    <div id="footer" class="mx-auto">
      <div id="footnav">
      <ul>
        <li><a href="//www.wenxuecity.com/aboutus/wenxuecity.shtml" target="_blank">文学城简介</a></li>
        <li><a href="//ads.wenxuecity.com/" target="_blank">广告服务</a></li>
        <li><a href="//www.wenxuecity.com/aboutus/contact.shtml" target="_blank">联系我们</a></li>
        <li><a href="//career.wenxuecity.com/" target="_blank">招聘信息</a></li>
        <li><a href="//passport.wenxuecity.com/register.php" target="_blank">注册笔名</a></li>
        <li><a href="/bbs/index.php?act=moderator" target="_blank">申请版主</a></li>
        <li class="last"><a href="#" target="_blank" onclick="return favorite(window.location,document.title);">收藏文学城</a></li>
      </ul>
    </div>
      <div class="info">
        <p>WENXUECITY.COM does not represent or guarantee the truthfulness, accuracy, or reliability of any of communications posted by other users. </p>
        <p><strong>Copyright ©1998-2022 <span class="url">wenxuecity.com</span> All rights reserved.</strong>
          <a href="//www.wenxuecity.com/aboutus/privacy.shtml" target="_blank"><span>Privacy Statement</span></a> &amp;
          <a href="//www.wenxuecity.com/aboutus/tou.shtml" target="_blank"><span>Terms of Use</span></a>
        </p>
      </div>
      <img src="//pixel.wenxuecity.com/images/pixel.gif?refe=none" style="display: none" height="1" width="1">
    </div>
<!--    <div class="container  mt-3">-->
<!--      <p class="mt-3 mb-1 text-small">Copyright ©{{ copyright }} wenxuecity.com</p>-->
<!--      <ul class="list-inline">-->
<!--        <li class="list-inline-item"><a href="https://www.wenxuecity.com/aboutus/privacy.shtml" className="small">Privacy Policy</a>-->
<!--       </li>-->
<!--        <li class="list-inline-item"><a href="https://www.wenxuecity.com/aboutus/tou.shtml" className="small">Terms of Use</a></li>-->
<!--        <li class="list-inline-item"><a href="https://www.wenxuecity.com/aboutus/wenxuecity.shtml" className="small">About</a></li>-->
<!--    </ul>-->
<!--    </div>-->
  </footer>
  <footer v-else class="d-none d-sm-block main-footer mt-3">
    <div class="container mt-2">
    <p className="small d-inline mb-1">Copyright ©{{ copyright }} Haiwai.com</p>
      <ul class="list-inline">
        <li class="list-inline-item"><a href="/privacy" className="small">Privacy Policy</a></li>
        <li class="list-inline-item"><a href="/tou" className="small">Terms of Use</a></li>
        <li class="list-inline-item"><a href="/about" className="small">About</a></li>
      </ul>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'right-footer',
  components: {},
  data() {
    return {
      copyright: new Date().getFullYear()
    }
  }
};
</script>
<style>
footer p, footer a {
  color: #8194a5
}

.main-footer {
  padding: 1.5rem 0;
  color: #999;
  text-align: center;
  /*background-color: #f9f9f9;*/
  /*border-top: 0.05rem solid #e5e5e5;*/
}
#footer { background: #f6f6f6 0 0; clear: both; font-size: 12px; padding-bottom: 15px; text-align: center; width: 1000px }
#footnav { border-top: 1px solid #ddd; margin: 0 5px; width: 990px }
#footer ul{width:600px;list-style: none;text-align:center;font-size:14px;margin:4px auto 10px auto;}
#footer ul li{float:left;margin:4px 10px;}
#footer a{color:#000;}

#footnav ul{width:625px;margin:0px auto;overflow:hidden;padding:0px;}
#footnav ul li{float:left;list-style:none;margin:4px 6px;}
#footnav a:link,#footnav a:visited{color:#009;}
#footnav ul li.last { border: 0 none }
#footer .info span.url, #footnav ul li.selected a { color: #609 }
#footer .info span, #footnav a { color: #00f; text-decoration: none }
#footer .info { clear: both; color: #000; font-family: Tahoma, Geneva, sans-serif; font-size: 11px; margin-top: 5px; overflow: hidden }
#footer .info p { margin: 0; padding: 0 }
#footer .info p a { text-decoration: none }
#copyright{clear:both;overflow:hidden;font-family:Tahoma,Geneva,sans-serif;font-size:11px;color:#000;margin-top:5px;}
#copyright a:link, #copyright a:visited {
  color: #009;
  text-decoration: none;
}

</style>
